import { combineReducers } from "redux";
import DashboardDesigner from "./DashboardDesigner";
import QueryBuilder from "./QueryBuilder";
import Organization from "./Organization";

export default combineReducers({
	...DashboardDesigner,
	...QueryBuilder,
	...Organization
});
